// removed by extract-text-webpack-plugin
module.exports = {"connection-container":"ConnectionProfile__connection-container___1EIh1","left-side":"ConnectionProfile__left-side___1dcM_","right-side":"ConnectionProfile__right-side___RW6xC"};